import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Button, IconArrowRight as ArrowRight } from '../../../../core';

type NewsItemProps = {
  className?: string;
  imgSrc: string;
  time: string;
  title: string;
  description: string;
  titleTag?: 'h2' | 'h3';
};

const NewsItem = ({
  className = '',
  imgSrc,
  time,
  title,
  description,
  titleTag: TitleTag = 'h2',
}: NewsItemProps) => {
  const navigate = useNavigate();

  return (
    <div className={className}>
      <img src={imgSrc} alt="img" />

      <div className="news-meta">
        <div className="news-meta__time">{time}</div>
        <TitleTag className="news-meta__title">{title}</TitleTag>
        <p className="news-meta__description">{description}</p>

        <Button
          onClick={() => navigate('/get-started/news/design-evolved', { replace: true })}
          size="S"
          variant="subtle"
          iconAfter={<ArrowRight />}
        >
          Read More
        </Button>
      </div>
    </div>
  );
};

const StyledNewsItem = styled(NewsItem)`
  display: flex;
  gap: 24px;
  img {
    max-width: 330px;
    min-height: 100%;
    height: 197px;
    border-radius: 12px;
  }

  .news-meta {
    > .news-meta__time {
      width: fit-content;
      border-radius: 16px;
      font-size: ${({ theme }) => theme.fontSizes.xs};
      line-height: ${({ theme }) => theme.lineHeights.xs};
      padding: 7px 12px;
      font-weight: 500;
      color: ${({ theme }) => theme.neutralText};
      margin-bottom: 12px;
      border: 1px solid ${({ theme }) => theme.neutralBorder};
    }

    > .news-meta__title {
      font-size: 20px;
      line-height: 24px;
      font-weight: 400;
      color: ${({ theme }) => theme.neutralText};
      margin-bottom: 11px;
    }

    > .news-meta__description {
      font-size: ${({ theme }) => theme.fontSizes.base};
      line-height: 24px;
      color: ${({ theme }) => theme.neutralTextWeak};
      margin-bottom: 24px;
      font-weight: 400;
    }
  }
`;

export default StyledNewsItem;
